import { Box, Divider, Typography } from "@mui/material";
import { ChatBubbleOutline, DataObjectOutlined, SlideshowOutlined, TableChartOutlined } from "@mui/icons-material";

import { Study } from "../../models";
import { EditStudyContext } from "../useEditStudyContext";
import EditDocumentFileUpload from "./EditDocumentFileUpload";
import { FileType } from "../manageStudyModels";

interface Props {
  study: Study;
  edit_context: EditStudyContext;
}

export default function EditStudyDocumentFiles({ study, edit_context }: Props) {
  const { isPowerPoint } = edit_context;

  // TODO: Determine this logic one layer up
  // const isPresentationSection: boolean = label === "Presentation";
  // const hasPresentationFile: boolean = Boolean(presentationFile);
  // const hasOtherFiles: boolean = Boolean(screenerSummaryFile || screenerGuideFile || discussionGuideFile);

  // const isDisabled: boolean =
  //   (hasPresentationFile && !isPresentationSection) || (hasOtherFiles && isPresentationSection);

  return (
    <Box>
      {!isPowerPoint ? (
        <>
          <EditDocumentFileUpload
            study={study}
            fileEditState={edit_context.getGuideFile(FileType.SCREENER_SUMMARY)}
            edit_context={edit_context}
            icon={TableChartOutlined}
            label={
              <Box>
                Screener Summary - <DownloadTemplateLink />
              </Box>
            }
          />
          <EditDocumentFileUpload
            study={study}
            fileEditState={edit_context.getGuideFile(FileType.SCREENER_GUIDE)}
            edit_context={edit_context}
            icon={DataObjectOutlined}
            label={"Screener Guide"}
          />
          <EditDocumentFileUpload
            study={study}
            fileEditState={edit_context.getGuideFile(FileType.DISCUSSION_GUIDE)}
            edit_context={edit_context}
            icon={ChatBubbleOutline}
            label={"Discussion Guide"}
          />
        </>
      ) : (
        <>
          {/* <Divider sx={{ mt: "1rem", mb: "1.2rem" }} /> */}
          <EditDocumentFileUpload
            study={study}
            fileEditState={edit_context.getGuideFile(FileType.POWERPOINT)}
            edit_context={edit_context}
            icon={SlideshowOutlined}
            label={"Presentation"}
          />
        </>
      )}
    </Box>
  );
}

const DownloadTemplateLink = () => {
  const handleTemplateDownload = () => {
    const link = document.createElement("a");
    link.href = `/assets/screener_summary_template.csv`;
    link.download = "Screener_Summary_Template.csv"; // Name of the downloaded file
    link.click();
  };

  return (
    <Typography
      onClick={handleTemplateDownload}
      sx={{
        fontSize: "12px",
        fontWeight: "400",
        textDecoration: "underline",
        cursor: "pointer",
        ml: "2px",
        display: "inline",
      }}
    >
      download template
    </Typography>
  );
};
